import { render, staticRenderFns } from "./addressItem.vue?vue&type=template&id=709fdbb1&"
import script from "./addressItem.vue?vue&type=script&lang=js&"
export * from "./addressItem.vue?vue&type=script&lang=js&"
import style0 from "./addressItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports